/*
A PDU has this general format:

uint32_t ConnectionID;
uint16_t SequenceNumber;
uint16_t AckNumber;
uint16_t PDUType;
uint16_t PayloadLength;
Payload

Payload may contain tagged data items. Each data item looks like this:

uint16_t Name
uint16_t Length
Data
*/
(function() {
 var oldpdus = [13,10,2,11,3,23,24,25,26,130,131,132,133,134,64,65,66,32768,515,21,32769,32770,34952];
function packetbuilder(tbox) {
 var that = this;
 var _bytes = new Array();
 var _ackNumber;
 var _seqNumber;
 var _connID;
 var _pduType;
 var TB = tbox?tbox:toolbox;
 var tb = new TB() ;
 
 // Adds empty bytes
 function addEmptyBytes(count) {
  for(var i=0; i<count; i++) _bytes.push(0);
 }
 
 // Extract data items from a tagged list
 this.extractdataitems = function(pld, length) {
  if(length===undefined) length=pld.length;
  var ditems = {};
  for(var i=0; i<length; ) {
   var di = {}; //data item
   var din = tb.getLittleEndianInt16(pld, i); //data item name
   di['l'] = tb.getLittleEndianInt16(pld, i+2); //data item length
   di['d'] = tb.getBytes(pld, i+4, di['l']); //data
   ditems['di'+din] = di;
   i += (2+2+di['l']);
  }

  return ditems;
 };

 // Sets header attributes
 this.setHeader = function(ackNumber,seqNumber,connID,pduType) {
  _ackNumber = ackNumber;
  _seqNumber = seqNumber;
  _connID = connID;
  _pduType = pduType;
  return that;    
 };

 // Adds 16 bit integer
 this.addInt16 = function(int16) {
  var index = _bytes.length;
  addEmptyBytes(2);
  tb.setLittleEndianInt16(_bytes, index, int16);
  return that;
 };

 // Adds 32 bit integer
 this.addInt32 = function(int32) {
  var index = _bytes.length;
  addEmptyBytes(4);
  tb.setLittleEndianInt32(_bytes, index, int32);
  return that;
 };

 // Adds string
 this.addString = function(string){
  for(var i=0; i<string.length; i++) _bytes.push(string.charCodeAt(i));
  return that;
 };

 // Adds byte
 this.addByte = function(byte) {
  _bytes.push(tb.getByte(byte, true));
  return that;
 };

 // Adds bytes
 this.addBytes = function(bytes) {
  _bytes = _bytes.concat(bytes);
  return that;
 };

 // Add bytes with length
 // {tag:,[bytes|string|number:]}
 this.addItem = function(input) {
  if(input.hasOwnProperty('tag')) this.addInt16(input.tag);
  if(input.hasOwnProperty('bytes'))
   this.addInt16(input.bytes.length).addBytes(input.bytes);
  else if(input.hasOwnProperty('string')) {
   var str = tb.utf8Encode(input.string);
   this.addInt16(str.length).addString(str);
  }else if(input.hasOwnProperty('number')) {
   this.addItem({bytes:tb.number2Bytes(input.number)});
  }else if(input.hasOwnProperty('int32')) {
   this.addInt16(4).addInt32(input.int32);
  }else if(input.hasOwnProperty('int8')) {
   this.addInt16(1).addByte(input.int8);
  }else throw new Error("couldn't find much to add here");
  return this;
 };

 // Gets bytes
 this.getBytes = function(header) {
  var bytes = new Array();
  if(header) {
   var pbh = new packetbuilder(TB);
   pbh.addInt32(_connID);
   pbh.addInt16(_seqNumber);
   pbh.addInt16(_ackNumber);
   pbh.addInt16(_pduType);
   pbh.addInt16(_bytes.length);
   bytes = bytes.concat(pbh.getBytes());
  }
  return bytes.concat(_bytes);
 };

 // Extract packet (json object) from bytes
 this.extractpacket = function() {
  if(_bytes.length < 12) return null;
  var h = {
   cid: tb.getLittleEndianInt32(_bytes,0), // connection id
   sn:  tb.getLittleEndianInt16(_bytes,4),  // seq no
   an:  tb.getLittleEndianInt16(_bytes,6),  // ack no
   pt:  tb.getLittleEndianInt16(_bytes,8),  // pdu type
   l:   tb.getLittleEndianInt16(_bytes,10)  // len
  };
  var pld = tb.getBytes(_bytes,12,h.l);
  if(!pld) return null;
  return {
   h: h,
   pl: oldpdus.indexOf(h.pt)!=-1
       ? pld
       : that.extractdataitems(pld)
  };
 };
 
 // Extract data item array (json object) from bytes
 this.extractarray = function() {
  var bytes = _bytes;
  var array = new Array();
  while(bytes.length > 0) {
   var length = tb.getLittleEndianInt16(bytes, 0);
   var pld = tb.getBytes(bytes, 2, length);
   array.push(that.extractdataitems(pld, length));
   bytes = tb.getBytes(bytes, 2+length, bytes.length-(2+length));
   if(!bytes) bytes = new Array();
  }
  return array;
 };
}

if(typeof module !== 'undefined' && typeof module.exports !== 'undefined') module.exports = packetbuilder;
else window.packetbuilder = packetbuilder;
})();
/* vim:set expandtab: */
